import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=46c417f0"
import script from "./HomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c417f0')) {
      api.createRecord('46c417f0', component.options)
    } else {
      api.reload('46c417f0', component.options)
    }
    module.hot.accept("./HomePage.vue?vue&type=template&id=46c417f0", function () {
      api.rerender('46c417f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/pages/home/HomePage.vue"
export default component.exports